module.exports = __webpack_public_path__ + "static/media/third_card.2c5caa7b.png";